import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/event/2206_rainy_season/kv.png'
import _imports_1 from '@/assets/img/event/ueno/ueno-photograph.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-35c4474c")

_pushScopeId("data-v-35c4474c")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "kv",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "main-container" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "main-top" }, [
  /*#__PURE__*/_createVNode("div", { class: "main-top-container" }, [
    /*#__PURE__*/_createVNode("p", { class: "main-top-container-headline" }, "梅雨こそおうちでonlylive！"),
    /*#__PURE__*/_createVNode("p", { class: "main-top-container-sub-headline" }, "大型ビジョン単独出演権オーディション🎉"),
    /*#__PURE__*/_createVNode("p", { class: "main-content-bottom" }, [
      /*#__PURE__*/_createTextVNode("大型ビジョンに"),
      /*#__PURE__*/_createVNode("span", { class: "span-red" }, "「自分1人だけ」"),
      /*#__PURE__*/_createTextVNode("が10秒間の自己PRで出演できるチャンス！"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("7位までに入賞された方にもビジョン出演のチャンスが！")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "move-ranking" }, [
    /*#__PURE__*/_createVNode("a", {
      class: "event-info-link",
      href: "#ranking"
    }, "現在のランキングをチェック ✅")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "photograph" }, [
    /*#__PURE__*/_createVNode("div", { class: "under-circle" }, [
      /*#__PURE__*/_createVNode("img", {
        class: "photograph-circle-img",
        src: _imports_1
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("a", {
    class: "photograph-btn",
    href: "https://onlylive.tokyo/",
    target: "_brank"
  }, [
    /*#__PURE__*/_createVNode("p", { class: "entry-form-btn-content" }, "onlyliveとは")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "event-info" }, [
    /*#__PURE__*/_createVNode("p", { class: "event-info-headline" }, "【開催期間・概要】"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail-date" }, "2022.6.25（土）00:00 ~ 2022.7.9（土）23:59"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, "参加資格：年齢、性別不問"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, "※出演料の支給はございません。"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-headline" }, "【ランキングスコア獲得キャンペーン】"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, [
      /*#__PURE__*/_createVNode("span", { class: "span-red" }, "合計800スコア"),
      /*#__PURE__*/_createTextVNode("を獲得できるキャンペーンを実施！")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, [
      /*#__PURE__*/_createTextVNode("通話による獲得スコアが"),
      /*#__PURE__*/_createVNode("span", { class: "span-red" }, "1.5倍"),
      /*#__PURE__*/_createTextVNode("になる期間も...✨")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "event-info-headline" }, "①スタートダッシュキャンペーン その１"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, "SNSでイベント告知をすると300スコア獲得！"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-headline" }, "②スタートダッシュキャンペーン その２"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, [
      /*#__PURE__*/_createVNode("span", { class: "with-border-text" }, "6.18（土） ~ 6.24（金）"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("上記期間中のプレランキングに応じて、"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("イベント開始時に特別スコアを付与！"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("1位 500スコア"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("2位 300スコア"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("3位 200スコア"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("4位 ~ 10位 100スコア"),
      /*#__PURE__*/_createVNode("br")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "event-info-headline" }, "③獲得スコア1.5倍キャンペーン"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, [
      /*#__PURE__*/_createVNode("span", { class: "with-border-text" }, "7.1（金） ~ 7.3（日）"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("通話にて獲得できるスコアが1.5倍に！")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "event-info-headline" }, "④ラストスパートキャンペーン"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, [
      /*#__PURE__*/_createVNode("span", { class: "with-border-text" }, "7.7（木） ~ 7.9（土）"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("ミーティングを開催すると最大300スコア獲得！")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "entry-form-content" }, [
      /*#__PURE__*/_createVNode("span", null, "＼飛び込みオーディション参加可能／"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("onlylive配信をご希望の方はこちら")
    ]),
    /*#__PURE__*/_createVNode("a", {
      class: "photograph-btn",
      href: "https://apps.apple.com/jp/app/onlylive-%E3%82%AA%E3%83%B3%E3%83%AA%E3%83%BC%E3%83%A9%E3%82%A4%E3%83%96-talent/id1558127728",
      target: "_brank"
    }, [
      /*#__PURE__*/_createVNode("p", { class: "entry-form-btn-content" }, "アプリインストール")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "event-info-title" }, "『大型ビジョン出演権オーディション』"),
    /*#__PURE__*/_createVNode("a", {
      class: "event-info-link",
      href: "#benefits"
    }, "▼ランキング特典はこちら▼")
  ])
], -1)
const _hoisted_5 = { class: "event-ranking-body-section" }
const _hoisted_6 = {
  class: "ranking-section",
  id: "ranking"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { id: "benefits" }, [
  /*#__PURE__*/_createVNode("div", { class: "benefits-section" }, [
    /*#__PURE__*/_createVNode("span", null, [
      /*#__PURE__*/_createVNode("p", { class: "benefits-section-headline" }, "【ランキング特典】"),
      /*#__PURE__*/_createVNode("p", { class: "benefits-section-caution" }, "エントリー前に必ず日程をご確認ください。"),
      /*#__PURE__*/_createVNode("div", { class: "benefits-top" }, [
        /*#__PURE__*/_createVNode("div", { class: "rank-top" }, [
          /*#__PURE__*/_createVNode("h3", null, "1位")
        ]),
        /*#__PURE__*/_createVNode("div", { class: "benefits-common" }, [
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail" }, [
            /*#__PURE__*/_createTextVNode("上野広小路・御徒町付近の「上野ビジョン広告」に"),
            /*#__PURE__*/_createVNode("span", { class: "span-border" }, "1人"),
            /*#__PURE__*/_createTextVNode("で出演✨")
          ]),
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail-caution" }, [
            /*#__PURE__*/_createTextVNode("掲載・掲出期間 2022.9ごろ放映予定"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("（1時間に1回、約15秒間の放映予定）")
          ])
        ])
      ]),
      /*#__PURE__*/_createVNode("div", { class: "benefits-top" }, [
        /*#__PURE__*/_createVNode("div", { class: "rank-top" }, [
          /*#__PURE__*/_createVNode("h3", null, "2位、3位")
        ]),
        /*#__PURE__*/_createVNode("div", { class: "benefits-common" }, [
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail" }, [
            /*#__PURE__*/_createTextVNode("「上野ビジョン広告」に"),
            /*#__PURE__*/_createVNode("span", { class: "span-border" }, "2人"),
            /*#__PURE__*/_createTextVNode("で出演✨")
          ]),
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail-caution" }, "掲載・掲出期間 同上")
        ]),
        /*#__PURE__*/_createVNode("div", { class: "rank-top-special" }, [
          /*#__PURE__*/_createVNode("h3", null, "1位〜7位")
        ]),
        /*#__PURE__*/_createVNode("div", { class: "benefits-common" }, [
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail" }, [
            /*#__PURE__*/_createTextVNode("「上野ビジョン広告」に"),
            /*#__PURE__*/_createVNode("span", { class: "span-border" }, "みんな"),
            /*#__PURE__*/_createTextVNode("で出演✨")
          ]),
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail-caution" }, "掲載・掲出期間 同上"),
          /*#__PURE__*/_createVNode("p", { class: "entry-form-content" }, [
            /*#__PURE__*/_createVNode("span", null, "＼飛び込みオーディション参加可能／"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("onlylive配信をご希望の方はこちら")
          ]),
          /*#__PURE__*/_createVNode("a", {
            class: "photograph-btn",
            href: "https://apps.apple.com/jp/app/onlylive-%E3%82%AA%E3%83%B3%E3%83%AA%E3%83%BC%E3%83%A9%E3%82%A4%E3%83%96-talent/id1558127728",
            target: "_brank"
          }, [
            /*#__PURE__*/_createVNode("p", { class: "entry-form-btn-content" }, "アプリインストール")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "notes-section" }, [
  /*#__PURE__*/_createVNode("div", { class: "notes-section-container" }, [
    /*#__PURE__*/_createVNode("p", { class: "notes-top-title" }, "注意事項"),
    /*#__PURE__*/_createVNode("ul", { class: "notes-contents" }, [
      /*#__PURE__*/_createVNode("li", null, [
        /*#__PURE__*/_createTextVNode(" ・"),
        /*#__PURE__*/_createVNode("span", { class: "span-border" }, "1位〜3位の方"),
        /*#__PURE__*/_createTextVNode("は、東京都内スタジオにてビジョン動画の撮影を行います。（動画を送付いただく形での出演も可）詳細は事務局にお問い合わせください。")
      ]),
      /*#__PURE__*/_createVNode("li", null, "・2022.6.25（土）00:00:00 以降の通話開始分から、2022.7.9（土）23:59:59 までの通話開始分がランキングに加算されます。"),
      /*#__PURE__*/_createVNode("li", null, "・2022.7.9（土）23:59:59 に通話が開始された場合、終了するまでがランキングに加算されます。（延長分も加算されます）"),
      /*#__PURE__*/_createVNode("li", null, "・最終ランキングの発表は、2022.7.11を予定しております。")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "footer" }, [
    /*#__PURE__*/_createVNode("p", null, "© 2022 ILEO,inc.")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Ranking = _resolveComponent("Ranking")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Ranking, {
            event: _ctx.state.event,
            rankingUsers: _ctx.state.ranking,
            getRankingPath: "rainy_season_2206_ranking",
            getEnableEventPath: "enable_rainy_season_2206_event",
            isPreEvent: false
          }, null, 8, ["event", "rankingUsers"])
        ])
      ]),
      _hoisted_7
    ]),
    _hoisted_8
  ]))
})